"use client";
import { SOLUTIONS_COMP } from "./constants";
import { Box, Stack, Flex, Separator, Icon } from "@chakra-ui/react";
import Image from "next/image";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import Link from "next/link";
import { FiArrowUpRight } from "@onemind-services-llc/react-icons-ng/fi";
import { Heading, Text, Button } from "@/elements";
import DottedBgImage from "public/shared/dotted-background-image.png";

const Solutions = () => {
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();
  const { LeftPanel, RightPanel } = SOLUTIONS_COMP;
  return (
    <Flex direction={{ base: "column", md: "row" }}>
      <Box position="relative" flex={"0 0 60%"} borderRadius={"8px"}>
        <Image
          src={DottedBgImage}
          alt=""
          fill
          style={{
            objectFit: "cover",
            zIndex: -1,
            borderRadius: "8px",
          }}
          priority={false}
        />
        <Stack
          gap={8}
          width={{ base: "100%", md: "85%" }}
          py={{ base: 10, md: 20 }}
          px={{ base: 6, md: 20 }}
        >
          <Heading as="h2" variant={HeadingVariant} color="white">
            {LeftPanel.title}
          </Heading>
          <Stack gap={3}>
            {LeftPanel.content.map((item, index) => (
              <Text key={index} variant={TextVariant} color="white">
                {item}
              </Text>
            ))}
          </Stack>
          <Button
            as={Link}
            variant={"secondary"}
            href={LeftPanel.button.link}
            width={"fit-content"}
          >
            {LeftPanel.button.label}
          </Button>
        </Stack>
      </Box>
      <Box
        my={{ base: "-4vw", md: "2vw" }}
        mx={{ base: "5vw", md: "5vw" }}
        ml={{ md: "-10%" }}
        backgroundColor={"white"}
        flex={"0 0 50%"}
        borderRadius={"8px"}
        justifyContent={"space-around"}
        boxShadow={"xl"}
        p={{ base: 5, md: 10 }}
      >
        {RightPanel.features.map((item, index) => (
          <Box key={index}>
            <Box color="primary.200">
              <Icon as={item.icon} boxSize={6} mr={1} pt={1} />
              <Heading variant={"subTitle3"} as="span">
                {item.title}
              </Heading>{" "}
              :{" "}
              <Text variant={"body2"} as="span" color="text.100">
                {item.content}
              </Text>
            </Box>
            <Button
              as={Link}
              href={item.button.link}
              variant={"link"}
              color="text.100"
              _hover={{ color: "white" }}
              px={2}
              marginTop={0}
            >
              {item.button.label}
              <FiArrowUpRight />
            </Button>
            <Separator my={3} />
          </Box>
        ))}
        <Text variant={TextVariant} color="text.100" fontWeight={600}>
          {LeftPanel.conclusion}
        </Text>
      </Box>
    </Flex>
  );
};

export default Solutions;
